import { fetchFromOldApi } from '~/services/Http';

export type EmplOtherHistoryType = {
  fEmplDateStart: string;
  fEmplType: string;
  fEmplCurrency: string;
  fEmplTrialPeriod: string;
  fEmplTrialPeriodEndDate: string;
  fEmplLastDateEmployment: string;
  fEmplTerminationDate: string;
  fEmplTerminationReason: string;
  fEmplFixedTermReason: string;
  fEmplPlannedEndDate: string;
  fEmplEnteredTime: string;
  fEmplEnteredUser: number;
  fEmplInfo?: number;
};

export const getEmplOtherHistory = (
  id: string | number,
): Promise<EmplOtherHistoryType[]> => {
  return fetchFromOldApi(
    '/json/employee/' + id + '/employment?period=edited',
  ).then((r) => r.json());
};
